import request from './index'

// 查询事业单位公开招考列表
export function getexamApi(params) {
  return request({
    url: '/common-api/exam/recruit/list',
    method: 'get',
    params
  })
}
//查询事业单位公开招考列表V2
export function getexamV2Api(params) {
  return request({
    url: '/common-api/unit-recruit-api/user/unit/companys',
    method: 'get',
    params
  })
}
// 获取事业单位招聘详情
export function getexamDetailApi(id) {
  return request({
    url: `/common-api/exam/recruit/${id}/details`,
    method: 'get',
  })
}
// 获取事业单位招聘详情V2
export function getexamDetailV2Api(id) {
  return request({
    url: `/common-api/unit-recruit-api/${id}/details`,
    method: 'get',
  })
}
// 查询日常招聘列表
export function getsimpleApi(params) {
  return request({
    url: '/common-api/simple/recruit/list',
    method: 'get',
    params
  })
}
// 查询日常招聘列表V2
export function getsimpleV2Api(params) {
  return request({
    url: '/common-api/recruit-api/companys',
    method: 'get',
    params
  })
}
// 获取日常招聘详情
export function getsimpleDetailApi(id) {
  return request({
    url: `/common-api/simple/recruit/${id}/details`,
    method: 'get',
  })
}
// 获取日常招聘详情V2
export function getsimpleDetailV2Api(params) {
  return request({
    url: `/common-api/recruit-api/companyRecruits`,
    method: 'get',
    params
  })
}
//获取招聘会信息
export function getjobfairApi(params) {
  return request({
    url: '/common-api/job-fair-api/items',
    method: 'get',
    params
  })
}
//获取岗位详情
export function getjobfairDetailApi(id) {
  return request({
    url: `common-api/recruit-api/user/${id}`,
    method: 'get',
  })
}
//获取报考岗岗位信息
export function getexamInfoApi(params) {
  return request({
    url: '/common-api/recruit-api/user/recruits',
    method: 'get',
    params
  })
}
// 获取手机验证码
export function getphoneCodeApi(params) {
  return request({
    url: '/common-api/send/sms/code',
    method: 'post',
    params
  })
}
// 合同信息查询
export function getHasContractApi(params) {
  return request({
    url: '/common-api/contract/vaild',
    method: 'get',
    params
  })
}
// 合同信息详情
export function getContractInfoApi(params) {
  return request({
    url: '/common-api/contract',
    method: 'get',
    params
  })
}
// 获取小程序二维码
export function getqrcodeApi(params) {
  return request({
    url: '/common-api/wx/qr/code',
    method: 'get',
    params
  })
}

//生成登录二维码
export function getloginQrcodeApi() {
  return request({
    url:'/common-api/login/qr',
    method:'post',
  })
}
//获取二维码登录信息
export function getloginQrcodeInfoApi(code) {
  return request({
    url:`/common-api/login/qr/${code}/info`,
    method:'get',
  })
}
//获取简历列表
export function getresumeListApi(params) {
  return request({
    url:'/resume-api/mine/resume/list',
    method:'get',
    baseURL:'/rczp-xcx-v2/cgi-bin/',
    params
  })
}
//提交简历
export function postresumeListApi(id,accessToken) {
  return request({
    url:`/resume-api/mine/resume/details/${id}`,
    method:'get',
    baseURL:'/rczp-xcx-v2/cgi-bin/',
    params:{
      accessToken
    }
  })
}
//保存图片
export function postimageApi(img) {
  return request({
    url:`/upload/stream`,
    method:'post',
    data: {
      stream: img.split(',')[1],
      ext: 'png'
    },
  })
}
export function deliverSignData(data) {
  return request({
    url: '/deliver-record-api/submit?accessToken='+localStorage.getItem('accessToken'),
    method: 'post',
    baseURL:'/rczp-xcx-v2/cgi-bin/',
    data
  })
}

export default request



// WEBPACK FOOTER //
// ./src/api/exam.js